//#region Angular Imports

import { StateService } from "@uirouter/angularjs"

//#endregion

//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { Api, LocalDictionaryFactory } from './../api/api.module'
import { ColumnModel } from './../api/api.models'

import { BaseGridGridsterController, ScopeBaseGridsterGrid } from '../common/common.base.grid.gridster.controller'
import { BulkEditInitParams, CreateEditInitParams } from '../common/create-edit-popup/create-edit-popup.controller'
import { DetailsOptions } from './../common/details-popup/details-popup.directive'
import { GridController, GridTypes, ButtonsOptions } from '../common/grid/grid.controller'
import { LoggerService } from './../common/common.module'
import { MapOptions, MapLegendItem } from './../common/map2/map.directive.controller'
import { ItemSwapperResult, ItemSwapperPopupOptions, IItemSwapperPopup } from './../common/item-swapper'

import { CommonHelper, EventsNames, LocalizationHelper, MapHelper, IUserSession, TypeHelper } from '../../helpers'
import { GridContextMenuService } from "../../services/grid"
import { GroupingLocationService } from '../../services/grouping-locations'
import { SystemService } from '../../services/system'

import { Activity, Enums } from '../../models/common/'
import { ColumnInfo } from '../../models/custom';
import { OpBounds } from '../../models/custom/op-map-area'
import { OpLocation } from '../../models/core/op-location'


export interface GroupingLocationScope extends ScopeBaseGridsterGrid {

    itemSwapperPopupOptions: ItemSwapperPopupOptions<OpLocation>
    deleteConfirmationOptions: {
        title: string

        onConfirmed: () => void
    }
}

export class GroupingLocationController extends BaseGridGridsterController {

    // #region Members

    private grid: GridController<OpLocation>
    private itemSwapperPopup: IItemSwapperPopup<OpLocation>

    // #endregion


    // #region Ctor

    constructor(
        protected $scope: GroupingLocationScope,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        private logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        private gridContextMenuService: GridContextMenuService,
        protected userSession: IUserSession,
        protected systemService: SystemService,
        private groupingLocationService: GroupingLocationService,
        referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $state, userSession, systemService, api, localDictionary, null, null, Enums.SimaxModuleName[moduleName], referenceType, true)

        this.initializeItemSwapper()
        this.setConfirmationsOptions()
        this.setEvents()
        this.setMainGridOptions()
    }

    // #endregion


    // #region Events

    private onInitialized(e: any, grid: GridController<OpLocation>): void {
        this.dataGrid = e.component
        this.grid = grid

        this.setGridId(e.tableId)
        this.onGridInit(e.tableId)
    }

    private onAdd(): void {
        this.groupingLocationService
            .getCreateEditOptions()
            .then((createEditparams: CreateEditInitParams) => {
                this.$scope.$broadcast(
                    EventsNames.INITIALIZE_CREATE_EDIT_POPUP,
                    createEditparams
                )
            })
    }

    private onEdit(): void {
        if (this.grid.selectedCount == 1) {
            this.groupingLocationService
                .getCreateEditOptions(this.grid.selectedItemId)
                .then((createEditparams: CreateEditInitParams) => {
                    this.$scope.$broadcast(
                        EventsNames.INITIALIZE_CREATE_EDIT_POPUP,
                        createEditparams
                    )
                })
        }
        else {
            const columnCount = this.grid.dxGrid.columnCount()
            const columns = []

            for (let i = 0; i < columnCount; i++) {
                columns.push(this.grid.dxGrid.columnOption(i));
            }

            this.groupingLocationService
                .getBulkEditInitOptions(columns, this.grid.selectedGridItems)
                .then((bulkEditParameters: BulkEditInitParams) => {
                    this.$scope.$root.$broadcast(EventsNames.INITIALIZE_BULK_EDIT_POPUP, bulkEditParameters)
                })
        }
    }

    private onShowDetails(e: any): void {
        const detailsOptions: DetailsOptions = {
            hasPermission: true,
            idReferenceType: this.referenceType,
            moduleName: this.moduleName,
            pageItemsIds: this.grid.pageItemsIds,
            referenceObjectId: this.grid.selectedItemId,
        }

        this.showDetails(e, detailsOptions)
    }

    private onDelete(): void {
        this.$scope.$broadcast(
            EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.popupId,
            LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
        )
    }

    private onDeleted(): void {
        this.grid.dxGrid.refresh()
    }

    private onConfirmDelete(): void {
        this.groupingLocationService
            .deleteGroupingLocation(this.grid.selectedItemId)
            .then(() => {
                this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
            })
            .fail((error: any) => {
                this.logger.log(error)
            })
    }

    // #endregion


    // #region Location Assignment

    private setItemSwapperLeftGridDataSource(): void {
        this.itemSwapperPopup.itemSwapper.reset()
    }

    private openRewarehousingItemSwapper() {
        this.setItemSwapperLeftGridDataSource()
        this.itemSwapperPopup.show()
    }

    private initializeItemSwapper(): void {
        this.groupingLocationService
            .getDefaultAssignedLocationsItemSwapperOptions(this.moduleName, this.referenceType)
            .then((options: ItemSwapperPopupOptions<OpLocation>) => {
                options.onSave = (result: ItemSwapperResult<OpLocation>) => this.onAssignedLocationsSave(result)

                options.itemSwapperOptions.rightGridOptions.getDataSourceFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
                    if (this.itemSwapperPopup != null && this.itemSwapperPopup.isVisible()) {
                        return this.userSession
                            .getDataProvider()
                            .Location
                            .getAllLocationFilter(columns, pageNbr, pageSize, customWhereClause)
                    }

                    return $.Deferred<any>().resolve(TypeHelper.NullObjectListResult).promise()
                }

                options.itemSwapperOptions.leftGridOptions.getDataSourceFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
                    if (this.grid != null
                        && this.grid.selectedItem != null
                        && this.itemSwapperPopup != null
                        && this.itemSwapperPopup.isVisible()
                    ) {
                        return this.userSession
                            .getDataProvider()
                            .GroupingLocation
                            .getGroupingLocationAssignedLocationsPaginated(this.grid.selectedItemId, columns, pageNbr, pageSize, customWhereClause)
                    }

                    return $.Deferred<any>().resolve(TypeHelper.NullObjectListResult).promise()
                }

                this.$scope.itemSwapperPopupOptions = options

                this.$scope.itemSwapperPopupOptions.onInitialized = (itemSwapperPopup: IItemSwapperPopup<OpLocation>) => {
                    this.itemSwapperPopup = itemSwapperPopup
                }
            })
    }

    private onAssignedLocationsSave(result: ItemSwapperResult<OpLocation>): JQueryPromise<any> {
        return this.groupingLocationService
            .assignGroupingLocation(this.grid.selectedItemId, result)
            .then(() => {
            })
            .fail((error: any) => {
                this.logger.log(error);
            })
            .always(() => {
                this.grid.dxGrid.refresh();
            });
    }

    // #endregion


    // #region Setup

    private getContextMenuItems(isTouchScreen: boolean = false): any[] {
        const items = this.gridContextMenuService.getContextMenuItems(Enums.SimaxModuleName.Grouping_Location, {
            idReferenceTypes: this.grid.selectedItemsIds,

            onEdit: () => {
                this.onEdit()
            },

            onAssignedLocationsEdit: () => {
                this.itemSwapperPopup ? this.openRewarehousingItemSwapper() : this.initializeItemSwapper()
            },
        })

        return this.mergeWithDefaultItems(isTouchScreen, items)
    }

    private getGridButtonsOptions(): ButtonsOptions {
        return {
            enabled: true,

            showDetailsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_LIST) ? "['" + Activity[Activity.GROUPING_LOCATION_LIST] + "']" : null,
            deletePermissions: this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_DEL) ? "['" + Activity[Activity.GROUPING_LOCATION_DEL] + "']" : null,
            editPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_EDIT) ? "['" + Activity[Activity.GROUPING_LOCATION_EDIT] + "']" : null,
            addPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_ADD) ? "['" + Activity[Activity.GROUPING_LOCATION_ADD] + "']" : null,
            saveColumnSettingsPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP) ? "['" + Activity[Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP] + "']" : null,
            groupingLocationAssignLocationsPermission: this.userSession.getLoggedOperator().hasPermission(Activity.GROUPING_LOCATION_EDIT) ? "['" + Activity[Activity.GROUPING_LOCATION_EDIT] + "']" : null,

            onShowClick: (e: any) => this.onShowDetails(e),
            onAddClick: () => this.onAdd(),
            onEditClick: () => this.onEdit(),
            onDeleteClick: () => this.onDelete(),
            onShowMap: () => this.showMapDetails(),
            onGroupingLocationAssignLocations: (e: any) => this.itemSwapperPopup ? this.openRewarehousingItemSwapper() : this.initializeItemSwapper()
        }
    }

    private getMainGridDataSourceParser() {
        return (location: OpLocation) => {
            return {
                additionalFields: [{
                    key: MapHelper.LatitudeFieldName,
                    value: location.latitude
                }, {
                    key: MapHelper.LongitudeFieldName,
                    value: location.longitude
                }],
            }
        }
    }

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onDeleted()
        )

        this.$scope.showDetails = (e: any) => this.onShowDetails(e)
    }

    private setMainGridOptions(): void {
        $.when(
            this.userSession
                .getDataProvider().System
                .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS, this.moduleName),
            this.userSession
                .getDataProvider().System
                .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEFAULT_GRID_PARAMS, this.moduleName)
        )
            .then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
                // If you'll ever add export options here, use this.userSession.getDataProvider().groupingLocation.groupingLocationExport
                this.$scope.mainGridOptions = {
                    addCustomFilters: true,
                    buttonsOptions: this.getGridButtonsOptions(),
                    columnsDictionary: columns,
                    dataSourceParser: this.getMainGridDataSourceParser(),
                    defaultColumnsDictionary: defaultColumns,
                    exportMethod: 'locations',
                    getDataSourceMethod: this.userSession.getDataProvider().GroupingLocation.getGroupingLocationFilter,
                    idReferenceType: this.referenceType,
                    localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.groupingLocationSaved,
                    name: 'GroupingLocationsGrid',
                    preExecuteClearFilter: this.preExecuteGridClearFilter,
                    referenceId: this.referenceType,
                    type: GridTypes.MAIN,

                    allowColumnReordering: !this.userSession
                        .getLoggedOperator()
                        .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.GroupingLocationModuleMainGrid),

                    contextMenuItems: (isTouchScreen: boolean = false) => this.getContextMenuItems(isTouchScreen),
                    onDataReady: (data: any) => this.onDataReady(data),
                    onInitialized: (e: any, grid: GridController<OpLocation>) => this.onInitialized(e, grid),
                    onRowDoubleClick: (e: any) => this.onShowDetails(e),
                    onSelectionChanged: (e: any) => this.onSelectionChanged(e),
                    onUpdateGridsterPosition: (e: any) => this.setGridsterPosition(e),
                }
            })
    }

    private setConfirmationsOptions(): void {
        this.$scope.deleteConfirmationOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),

            onConfirmed: () => this.onConfirmDelete()
        }
    }

    // #endregion


    // #region BaseGridGridsterController Implementation

    protected onGridsterMapConfiguration(mapOptions: MapOptions): void {
        mapOptions.enableAreaSelect = true

        mapOptions.onAreaSelect = (bounds: OpBounds) => {
            MapHelper
                .getCoordColumnNames(this.userSession.getDataProvider())
                .then(([latColName, lonColName]: [string, string]) => {
                    this.addCustomGridFilter(CommonHelper.getLonLatFilter(bounds, latColName, lonColName, 'DepositoryFilterByMarkers'))
                })

        }

        MapHelper
            .getLegendItems(this.userSession.getDataProvider(), Enums.ReferenceType.IdLocation)
            .then((items: MapLegendItem[]) => {
                mapOptions.legendItems = items
            })
    }

    // #endregion
}